export default function (state, value) {
    state.loading = false;
    state.items = value;
}